import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy
} from '@angular/core';
import { AccountType, DirectoryUserDto, UserDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { DirectoryUserComponent } from '../directory-user/directory-user.component';
import { MessageService } from 'base';
import { UsersService } from '../../services/users.service';


@Component({
	selector: 'directory-user-dialog',
	templateUrl: './directory-user-dialog.component.html'
})
export class DirectoryUserDialogComponent implements OnInit, OnDestroy, OnChanges  {

	@Input()
	public visible: boolean;

	@Input()
	public userType: AccountType;

	@Input()
	public target: UserDto;

	@Input()
	public domains: string[];

	@Input()
	public create: boolean;

	@Input()
	public dirUsers: DirectoryUserDto[];

	@Input()
	public allowSearch: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<UserDto>;

	@Output()
	public onCancel: EventEmitter<any>;

    @ViewChild(DirectoryUserComponent, { static: true })
	public user: DirectoryUserComponent;

	private buttonClicked: boolean;

	constructor(private usersService: UsersService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.target = null;
		this.domains = [];
		this.create = false;
		this.dirUsers = [];
		this.allowSearch = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<UserDto>();
		this.onCancel = new EventEmitter<any>();

		this.buttonClicked = false;
	}

	public ngOnInit(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnDestroy(): void {

	}

	public get enableOk(): boolean {
		return this.user.enableApply;
	}

	public get dialogTitle(): string {
		let operationTitle = (this.create ? "Create" : "Edit");

		let userTypeTitle = ((this.userType == AccountType.ActiveDirectory) ?
			"Active Directory" : "Google Workspace");

		return `${operationTitle} ${userTypeTitle} User`;
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		if (this.buttonClicked) {
			this.buttonClicked = false;
		}
		else {
			this.doCancelActions();
		}
	}

	public onCancelClicked(): void {
		this.buttonClicked = true;
		this.doCancelActions();
	}

	private doCancelActions(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onOkClicked(): void {
		let isUpdate = !this.create;
		if (isUpdate && !this.updateIsSafe()) {
			this.messageService.displayErrorMessage("Cannot remove last administrator");
		}
		else {
			this.apply();
		}
	}

	private updateIsSafe(): boolean {
		return true;
	}

	private apply(): void {
		if (this.target) {
			this.user.applyTempChanges();

			if (this.create) {
				this.usersService.createUser(this.target, this.user.addedUserGroups, "").subscribe(
					(result: UserDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("User successfully created");
					},
					(error) => {
						this.messageService.displayErrorMessage("Creating user failed");
					});
			}
			else {
				this.usersService.updateUser(this.target, this.user.addedUserGroups,
					this.user.removedUserGroups, "").subscribe(
					(result: UserDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("User successfully updated");
					},
					(error) => {
						this.messageService.displayErrorMessage("Updating user failed");
					});
			}
		}
	}

}
